import { Injectable } from '@angular/core';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../../environments/environment';
import { ConsoleService } from '../../console.service';
import * as _ from 'lodash';

import { AWSClass, IAWSResponse, IAWSError, AWS_CLASS } from './../aws-class';
import { AWSAPIService, IAWSAPIRequestOpts } from './../helpers/aws-helper-api';
import { GlobalVarsService } from './../../global-vars.service';
import { AWSAuthService } from './../helpers/aws-helper-auth';
import { ModalService } from '../../modal.service';

export const WORKER_DEFAULT_IMG = 'data:image/png;base64,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';

export const AWS_DATA_EMPLOYEES = {
  actions: {
    authenticate_web: 'authenticateWeb',
  },
  errors: {}
}

export interface IAWSDataEmployeesPostBody {
  username: string,
  password: string,
  action?: string
}

export interface IAWSDataAuthenticateData {
  username: string,
  password: string,
  action?: string
}

export interface IAWSDataEmployeeGetParams {
  employeeId?: number,
  employeeIds?: number[],
  page?: number,
  pageSize?: number
  countries?: string[],
  ports?: string[],
  statuses?: string[],
  loadPic?: boolean,
  picLink?: string,
  keyword?: string,
  areaIds?: number[],
}

export interface IAWSEmployee {
  EmployeeId: number,
  Username?: string,
  FirstName?: string,
  LastName?: string,
  Email?: string,
  Mobile?: string,
  Telephone?: string,
  StreetAddress?: string,
  Suburb?: string,
  PostCode?: string,
  State?: string,
  CountryCode?: string,
  CountryName?: string,
  EmergencyName?: string,
  EmergencyNote?: string,
  EmergencyMobile?: string,
  EmergencyTelephone?: string,
  EmergencyStreetAddress?: string,
  EmergencySuburb?: string,
  PortName?: string,
  PortCode?: string,
  StartDate?: string,
  Pic?: string,
  ServiceTypeId?: number,
  ServiceTypeName?: string,
  Status?: string,
  LanguageCode?: string,
  PicLink?: string,
  TerminationDate?: string,
}

@Injectable()
export class AWSDataEmployeesService extends AWSClass {
  constructor(
    public AWSAPIService: AWSAPIService,
    public AWSAuthService: AWSAuthService,
    public globalVarsService: GlobalVarsService,
    public modalService: ModalService,
    public sanitizer: DomSanitizer,
    public consoleService: ConsoleService
  ) {
    //Call extending class constructor
    super(modalService, consoleService);
  }

  initOptions(): IAWSAPIRequestOpts {
    const opts: IAWSAPIRequestOpts = {
      path: environment.api.paths.employees,
      body: {}
    };

    return opts;
  }

  authenticate(authenticateData: IAWSDataAuthenticateData): Promise<IAWSResponse> {
    //Init options
    let options = this.initOptions();

    //Set anonymous request
    options.anonymous = true;

    //Set body
    const optionsBody: IAWSDataEmployeesPostBody = {
      username: authenticateData.username,
      password: authenticateData.password,
      action: AWS_DATA_EMPLOYEES.actions.authenticate_web,
    }
    options.body = optionsBody;

    //Hit API with POST method
    return this.AWSAPIService.post(options)
      .then((apiResponse) => {
        //Check for error
        if (apiResponse.status === AWS_CLASS.RESPONSES.STATUSES.SUCCESS) {
          //Get employee info from payload
          const employee = apiResponse.body;
          if (employee) {
            //Sign in user in AWS user pool
            return this.AWSAuthService.signIn(authenticateData.username, authenticateData.password)
              .then((signInResponse) => {
                return Promise.resolve(this.getSuccessResponse(signInResponse));
              })
              .catch((signInError) => {
                return Promise.reject(this.getErrorResponse(signInError, 'signIn'));
              });
          } else {
            //Error - No employee given
            return Promise.reject(this.getErrorResponse(null, 'signIn'));
          }
        } else {
          //Error
          return Promise.reject(this.getErrorResponse(apiResponse, 'authenticate'));
        }
      })
      .catch((apiError) => {
        return Promise.reject(this.getErrorResponse(apiError, 'authenticate', null, true));
      });
  }

  getErrorResponse(error: any, origin?: string, code?: number, showModal?: boolean): IAWSResponse {
    //Init code
    code = code ? code : parseInt(_.get(error, 'code', 0));

    //Check for error
    let errorBody: IAWSError = {
      code: code,
      description: _.get(error, 'message', null)
    };

    //Set message if error is handled
    switch (code) {
      case AWS_CLASS.RESPONSES.CODES.AUTH_401:
        //Unauthorized
        errorBody.description = 'Username/Password combination is invalid. Please check and try again.';
        break;
    }

    //Set error body
    if (!error) {
      error = {};
    }
    error['body'] = errorBody;

    return super.getErrorResponse(error, origin, code, showModal);
  }

  get(params: IAWSDataEmployeeGetParams): Promise<IAWSResponse> {
    //Init options
    let options = this.initOptions();

    //Set params
    if (params) {
      //Employee id
      if (params.employeeId) {
        options.path += params.employeeId;
      }

      //Init query string
      options.queryStringParams = {};

      //Page
      if (params.page) {
        options.queryStringParams['page'] = params.page;
      }

      //Page size
      if (params.pageSize) {
        options.queryStringParams['page_size'] = params.pageSize;
      }

      //Countries
      if (params.countries && params.countries.length > 0) {
        options.queryStringParams['countries'] = params.countries.join(',');
      }

      //Ports
      if (params.ports && params.ports.length > 0) {
        options.queryStringParams['ports'] = params.ports.join(',');
      }

      //Statuses
      if (params.statuses && params.statuses.length > 0) {
        options.queryStringParams['statuses'] = params.statuses.join(',');
      }

      //Load pic
      if (params.loadPic) {
        options.queryStringParams['load_pic'] = params.loadPic;
      }

      //Pic link
      if (params.picLink) {
        options.queryStringParams['pic_link'] = params.picLink;
      }

      //Keyword
      if (params.keyword) {
        options.queryStringParams['keyword'] = params.keyword;
      }

      //Areas
      if (params.areaIds && params.areaIds.length > 0) {
        options.queryStringParams['areas'] = params.areaIds.join(',');
      }

      //EmployeeIds
      if (params.employeeIds && params.employeeIds.length > 0) {
        options.queryStringParams['employeeIds'] = params.employeeIds.join(',');
      }
    }

    //Hit API with get method
    return this.AWSAPIService.get(options)
      .then((apiResponse) => {
        //Check for error
        if (apiResponse.status === AWS_CLASS.RESPONSES.STATUSES.SUCCESS) {
          //Get employee info from payload
          let employees = [];
          if (!params.employeeId) {
            employees = Array.isArray(apiResponse.body['data']) ? apiResponse.body['data'] : [apiResponse.body['data']];
          } else {
            employees = Array.isArray(apiResponse.body) ? apiResponse.body : [apiResponse.body];
          }

          //Populate data
          if (Array.isArray(employees)) {
            for (let employee of employees) {
              //Set Pic
              employee.Pic = this.getPic(employee);
            }
          }

          //Set response
          let response: any = null;
          if (!params.employeeId) {
            apiResponse.body['data'] = employees;
            response = apiResponse.body;
          } else {
            response = employees;
          }

          return Promise.resolve(this.getSuccessResponse(response));
        } else {
          //Error
          return Promise.reject(this.getErrorResponse(apiResponse, 'get'));
        }
      })
      .catch((apiError) => {
        return Promise.reject(this.getErrorResponse(apiError, 'get', null, true));
      });
  }

  getWorkerPic(params: IAWSDataEmployeeGetParams): Promise<IAWSResponse> {
    //Init options
    let options = this.initOptions();

    //Set params
    if (params) {
      //Init query string
      options.queryStringParams = {};

      //Pic link
      if (params.picLink) {
        options.queryStringParams['pic_link'] = params.picLink;
      }
    }

    //Hit API with get method
    return this.AWSAPIService.get(options)
      .then((apiResponse) => {
        //Check for error
        if (apiResponse.status === AWS_CLASS.RESPONSES.STATUSES.SUCCESS) {
          //Set response
          let response: string = apiResponse ? apiResponse.body : null;
          response = apiResponse.body;

          return Promise.resolve(this.getSuccessResponse(response));
        } else {
          //Error
          return Promise.reject(this.getErrorResponse(apiResponse, 'get'));
        }
      })
      .catch((apiError) => {
        return Promise.reject(this.getErrorResponse(apiError, 'get', null, true));
      });
  }

  getPic(employee: IAWSEmployee): SafeUrl {
    return (employee && employee.Pic) ? this.sanitizePic(employee.Pic) : WORKER_DEFAULT_IMG;
  }

  sanitizePic(pic: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(pic);
  }
}